/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const CREATE_ACTION_AI_CONTEXT_IMAGE = gql`
  mutation CreateActionAiContextImage($data: CreateActionAIContextImageInput!) {
    createActionAiContextImage(data: $data) {
      id
      bucketFileName
      url
      type
    }
  }
`
